import React from 'react';
import './App.css';
import * as tf from '@tensorflow/tfjs';
import '@tensorflow/tfjs-backend-webgl';
// import * as faceapi from 'face-api.js';
import * as faceapi from '@vladmandic/face-api';

var cv = window.cv;

var loadScript = function (src) {
  var tag = document.createElement('script');
  tag.async = false;
  tag.src = src;
  document.getElementsByTagName('body')[0].appendChild(tag);
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModelLoaded: false,
      filename: "",
      fileData: ""
    }

    this.videoCapture = null;
    this.videoOutputCanvasContext = null;
    // this.srcMat = new cv.Mat(width, height, cv.CV_8UC4);
    // this.dstMat = new cv.Mat(width, height, cv.CV_8UC1);
    this.srcMat = null;
    this.dstMat = null;
    this.resizedSrcMat = null;
    this.rotatedMat = null;
    this.processVideo = this.processVideo.bind(this);
    // this.processVideo = async () => { try { await this.processVideo() } catch (error) { console.log(error) } }
    this.runModel = this.runModel.bind(this);
    this.videoSize = null;
    this.model = null;
    this.cameraVideo = null;
    this.refImageTensor = null;
  }

  // euclidean_distance(a, b) {
  //   return Math.sqrt()
  // }
  async loadModels() {
    this.model = await tf.loadGraphModel('/tfjs_model/model.json')
    await faceapi.nets.ssdMobilenetv1.loadFromUri('/models');
    await faceapi.nets.tinyFaceDetector.loadFromUri('/models');
    await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
    this.model = await tf.loadGraphModel('/tfjs_model/model.json')
    console.log('loaded tf models');
    this.setState({ isModelLoaded: true });
  }

  componentDidMount() {
    // loadScript('/opencv.js');
    //eslint-disable-next-line
    // this.dstMat = new cv.Mat();
    // this.resizedSrcMat = new cv.Mat();
    // this.rotatedMat = new cv.Mat();
    this.loadModels();
  }

  async detectFace(frame) {
    const targetEyeDistcance = 82;
    const targetLeftEyePos = new faceapi.Point(110, 102);
    const targetMouthPos = 235;

    const detectionWithLandmarks = await faceapi.detectSingleFace(frame).withFaceLandmarks()
    if (!detectionWithLandmarks) throw Error();
    const landmarks = detectionWithLandmarks.landmarks;
    // console.log(landmarks.getLeftEye())
    const mouthLandmarks = landmarks.getMouth();
    let leftEyePos = landmarks.getLeftEye().reduce((prev, curr) => new faceapi.Point(prev.x + curr.x, prev.y + curr.y));
    let rightEyePos = landmarks.getRightEye().reduce((prev, curr) => new faceapi.Point(prev.x + curr.x, prev.y + curr.y));
    let mouthPos = mouthLandmarks.reduce((prev, curr) => new faceapi.Point(prev.x + curr.x, prev.y + curr.y));
    leftEyePos = new faceapi.Point(leftEyePos.x / 6, leftEyePos.y / 6);
    rightEyePos = new faceapi.Point(rightEyePos.x / 6, rightEyePos.y / 6);
    mouthPos = new faceapi.Point(mouthPos.x / mouthLandmarks.length, mouthPos.y / mouthLandmarks.length);

    const eyeOffset = new faceapi.Point(rightEyePos.x - leftEyePos.x, rightEyePos.y - leftEyePos.y);

    const angle = Math.atan2(eyeOffset.y, eyeOffset.x) * 180 / Math.PI;
    const eyeCenter = new faceapi.Point((rightEyePos.x + leftEyePos.x) / 2, (rightEyePos.y + leftEyePos.y) / 2);
    const mouthOffset = new faceapi.Point(mouthPos.x - eyeCenter.x, mouthPos.y - eyeCenter.y);
    const scaleX = targetEyeDistcance / Math.sqrt(eyeOffset.x ** 2 + eyeOffset.y ** 2);
    const scaleY = 86 / Math.sqrt(mouthOffset.x ** 2 + mouthOffset.y ** 2);

    // console.log(angle*180/Math.PI);
    return { angle, eyeCenter, scaleX, scaleY };
  }

  async setupCameraVideo() {
    const cameraVideoWrapper = document.getElementById("cameraVideoWrapper");
    const video = document.createElement('video');
    if (video === null) {
      console.error("Couldn't create video element");
      return;
    }
    this.videoSize = [1920, 1080];
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('width', `${this.videoSize[0]}px`);
    video.setAttribute('height', `${this.videoSize[1]}px`);

    // video.style.width = '200px';
    // video.style.height = '200px';
    // cameraVideoWrapper.appendChild(video);

    var facingMode = "user";
    var constraints = {
      audio: false,
      video: {
        facingMode: facingMode
      }
    };
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    video.srcObject = stream;
    this.videoCapture = new cv.VideoCapture(video)
    this.cameraVideo = video;
    setTimeout(() => this.processVideo(), 1000);
  }

  async processVideo() {
    let begin = Date.now();
    const FPS = 15;
    // try {
    const [width, height] = this.videoSize;
    if (this.videoOutputCanvasContext === null) {
      let canvasVideoOutput = document.getElementById("videoOutput");
      this.videoOutputCanvasContext = canvasVideoOutput.getContext("2d");
      this.srcMat = new cv.Mat(height, width, cv.CV_8UC4);
      this.srcMatC3 = new cv.Mat(height, width, cv.CV_8UC3);
      this.dstMat = new cv.Mat();
      this.resizedSrcMat = new cv.Mat();
      this.rotatedMat = new cv.Mat();
    }

    this.videoCapture.read(this.srcMat);
    cv.cvtColor(this.srcMat, this.srcMatC3, cv.COLOR_RGBA2RGB);
    let detectionResults;

    try {
      detectionResults = await this.detectFace(this.cameraVideo);
    }
    catch (error) {
      // console.log(error);
      let delay = 1000 / FPS - (Date.now() - begin);
      setTimeout(this.processVideo, delay);
      return;
    }
    const { angle, eyeCenter, scaleX, scaleY } = detectionResults;
    const rotationMatrix = cv.getRotationMatrix2D(new cv.Point(eyeCenter.x, eyeCenter.y), angle, 1.0);
    cv.warpAffine(this.srcMatC3, this.rotatedMat, rotationMatrix, new cv.Size(1920, 1080));
    cv.resize(this.rotatedMat, this.resizedSrcMat, new cv.Size(0, 0), scaleX, scaleY);

    const eyeCenterScaled = new faceapi.Point(eyeCenter.x * scaleX, eyeCenter.y * scaleY);
    const offset = new faceapi.Point(eyeCenterScaled.x - 165 / 1.41, eyeCenterScaled.y - 102 / 1.41);
    let cropped = null;
    try {
      cropped = this.resizedSrcMat.roi(new cv.Rect(Math.floor(offset.x), Math.floor(offset.y), 256, 256));

      const croppedClone = cropped.clone();
      const data = await this.runModel(croppedClone.data);
      croppedClone.delete();

      for (let row = 0; row < 256; row++) {
        for (let col = 0; col < 256; col++) {
          for (let channel = 0; channel < 3; channel++) {
            const idx1 = (row + Math.floor(offset.y)) * this.resizedSrcMat.cols * this.resizedSrcMat.channels() + (col + Math.floor(offset.x)) * this.resizedSrcMat.channels() + channel;
            const idx2 = row * 256 * 3 + col * 3 + channel;
            const dst = Math.min(255 - col, row, 255 - row, row);
            if (dst > 10) {
              this.resizedSrcMat.data[idx1] = data[idx2];
            } else {
              const alpha = (dst) / 10;
              this.resizedSrcMat.data[idx1] = alpha * data[idx2] + (1 - alpha) * this.resizedSrcMat.data[idx1];
            }
          }
        }
      }
      cv.resize(this.resizedSrcMat, this.resizedSrcMat, new cv.Size(0, 0), 1 / scaleX, 1 / scaleY);
      const reverseRotationMatrix = cv.getRotationMatrix2D(new cv.Point(eyeCenter.x, eyeCenter.y), -angle, 1.0);
      cv.warpAffine(this.resizedSrcMat, this.resizedSrcMat, reverseRotationMatrix, new cv.Size(1920, 1080));

      cv.imshow("videoOutput", this.resizedSrcMat);
      // mat.delete();
    } catch (error) {
      console.error(error)
    }
    if (cropped !== null) cropped.delete();

    // cv.imshow("videoOutput", cropped);

    let delay = 1000 / FPS - (Date.now() - begin);
    setTimeout(this.processVideo, delay);
  }

  runModel(srcImage) {
    // const inputTensor_ = tf.tensor(srcImage, [1, 3, 256, 256], 'float32');
    // const inputTensor = inputTensor_.transpose([0, 2, 3, 1]);
    const inputTensor = tf.tensor(srcImage, [1, 256, 256, 3], 'float32');
    const scaledInputTensor = tf.div(tf.cast(inputTensor, 'float32'), 255.0);
    const outputTensor = this.model.predict([scaledInputTensor, this.refImageTensor]);
    const reshaped = tf.reshape(outputTensor[0], [256, 256, 3]);
    const mul = tf.mul(reshaped, 255.0);
    const out = tf.cast(mul, 'int32');
    // tf.browser.toPixels(reshaped, document.getElementById("videoOutput"));
    // tf.browser.toPixels(scaledInputTensor.reshape([256, 256, 3]), document.getElementById("videoOutput"));
    return out.data()
  }

  handleFileLoad(files) {
    const fr = new FileReader();
    const canvas = document.createElement("canvas");
    canvas.setAttribute('width', '1000');
    canvas.setAttribute('height', '1000');
    const ctx = canvas.getContext("2d");
    fr.onload = () => {
      const img = document.getElementById("refImage");
      img.onload = () => {
        ctx.drawImage(img, 0, 0);
        const imageData = ctx.getImageData(0, 0, img.width, img.height).data;
        const removedAlphaChannel = imageData.filter((element, i) => i % 4 != 3);
        if (this.refImageTensor !== null) {
          tf.dispose(this.refImageTensor);
        }
        const refTensor = tf.tensor(removedAlphaChannel, [1, img.width, img.height, 3]);
        this.refImageTensor = tf.image.resizeBilinear(tf.div(refTensor, 255.0), [256, 256]);
        tf.browser.toPixels(tf.reshape(this.refImageTensor, [256, 256, 3]), document.getElementById("targetMakeupCanvas"));
        tf.dispose(refTensor);
      }
      img.src = fr.result;
    };
    fr.readAsDataURL(files[0]);
  }

  render() {
    if (!this.state.isModelLoaded) {
      return (
        <div>
          Downloading model. Please wait.
        </div>
      )
    }
    return (
      <div>
        <div id="cameraVideoWrapper"></div>
        <button onClick={() => this.setupCameraVideo()}>start video</button>
        <canvas id="videoOutput" />
        <img id="refImage" style={{ border: "1px" }} hidden />
        <canvas id="targetMakeupCanvas" width={256} height={256} />
        <input type="file" id="myFile" value="" onChange={e => this.handleFileLoad(e.target.files)} />
      </div>
    );
  }

}

export default App;
